import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { Tab, Tabs } from '@material-ui/core'

import { InspectionDetail } from './InspectionDetail'
import { FlagInventoryInspectionsHome } from './FlagInventoryInspections/FlagInventoryInspectionsHome'
import { InspectionActionItems } from './InspectionActionItems'
import { Container } from '../../components'
import {
    useAppDispatch,
    useAptConfig,
    useCompany,
    useSchedule,
    useService,
    useUser,
} from '../../hooks'
import { getStatusGroupList, getStatusList } from '../../store'

const DETAIL_TAB = 0
const FLAG_INVENTORY_INSPECTIONS_TAB = 1
const ACTION_ITEMS_TAB = 2

export const InspectionDetailHome = () => {
    const dispatch = useAppDispatch()
    const [selectedTab, setSelectedTab] = useState<number>(DETAIL_TAB)

    const { id } = useParams<{ id?: string }>()

    const { actions } = useUser()
    const { getUserList } = actions

    const { getScheduleList } = useSchedule()

    const { loadingState } = useAptConfig({
        unitConfigList: true,
        inventoryConfigList: true,
        areaConfigList: true,
        customStatusList: true,
    })

    const { serviceList } = useService({ getServiceList: true, cleanUp: true })
    const { vendorList } = useCompany({ getVendorList: true, cleanUp: true })

    useEffect(() => {
        getUserList({ params: { my_team: true } })
        dispatch(getStatusGroupList({}))
        dispatch(getStatusList({}))
        getScheduleList({})
    }, [])

    return (
        <Container
            style={{
                flex: 1,
                flexDirection: 'column',
                width: '100%',
                height: 'calc(100vh - 104px)',
            }}
        >
            <Tabs
                value={selectedTab}
                onChange={(_, newValue) => setSelectedTab(newValue)}
            >
                <Tab label="Detail" value={DETAIL_TAB} />
                <Tab label="Flags" value={FLAG_INVENTORY_INSPECTIONS_TAB} />
                <Tab label="Suggested Action Items" value={ACTION_ITEMS_TAB} />
            </Tabs>
            {selectedTab === DETAIL_TAB && <InspectionDetail />}
            {selectedTab === FLAG_INVENTORY_INSPECTIONS_TAB && (
                <FlagInventoryInspectionsHome
                    inspectionId={id ? parseInt(id) : undefined}
                />
            )}
            {selectedTab === ACTION_ITEMS_TAB && (
                <InspectionActionItems
                    inspectionId={id ? parseInt(id) : undefined}
                />
            )}
        </Container>
    )
}
